export const CHART_COLORS = [
  '#0054ea',
  '#00a650',
  '#f0b000',
  '#ea0000',
  '#6a1b9a',
  '#00acc1',
  '#f57c00',
  '#c62828',
]
